import { createFileRoute } from "@tanstack/react-router";
import { comingSoonPage } from "@/components/ComingSoon";
import { requireAuth } from "@/lib/auth-guard";

/**
 * Extended Family Circle — mirrors iOS LinksScreen.
 * Phase B wires: GET /api/v1/family-links?scope=active ·
 * POST /api/v1/family-links/{id}/revoke ({ownerDisposition}) ·
 * POST /api/v1/invites/mint (intent=link_efc, owner-only).
 * Accepting a link runs the sharing-bucket picker (share all / pick
 * per memory / off + "Share my past memories too"); each member sets
 * their own per-link policy on the Sharing page.
 */
export const Route = createFileRoute("/links")({
  loader: ({ context }) => requireAuth(context.queryClient),
  component: comingSoonPage(
    "Extended Family Circle",
    "Connect your circle with another family's and choose what flows between them. We're building this surface now.",
  ),
});
